<template>
  <div class="card">
    <div>
      <h3>工作</h3>
      <div class="tagList">
        <template v-for="item in showList">
          <div
            v-if="item.userType.includes(userType)"
            :key="item.id"
            class="tag"
            @click="onTag(item.id)"
          >
            <el-image :src="item.icon" fit="fill"></el-image>
            <div class="label">{{ item.label }}</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import icon1 from "@/assets/img/ecology/setting_1.png";
import icon2 from "@/assets/img/ecology/setting_2.png";
import icon3 from "@/assets/img/ecology/setting_3.png";
import icon4 from "@/assets/img/ecology/setting_4.png";
import icon5 from "@/assets/img/ecology/setting_5.png";

export default {
  data() {
    return {
      // userType :1 管理员，2 工程师，3 游客
      settingList: [
        {
          id: 1,
          icon: icon2,
          label: "报工",
          userType: [1, 2],
        },
        {
          id: 2,
          icon: icon3,
          label: "结算",
          userType: [1, 2],
        },
        {
          id: 3,
          icon: icon4,
          label: "新增账号",
          userType: [1],
        },
        {
          id: 4,
          icon: icon5,
          label: "行业标签申请",
          userType: [1],
        },
        {
          id: 5,
          icon: icon1,
          label: "能力标签申请",
          userType: [1, 2],
        },
      ],
    };
  },
  computed: {
    showList() {
      return this.settingList;
    },
    userType() {
      return +this.$store.state.ecology.userInfo.userType;
    },
  },
  methods: {
    onTag(id) {
      switch (id) {
        case 1:
          this.$router.push("/ecologicalServices/report-list");
          break;
        case 2:
          this.$router.push("/ecologicalServices/settlement-list");
          break;
        case 3:
          this.$router.push("/ecologicalServices/account-edit");
          break;
        case 4:
          this.$router.push("/ecologicalServices/company-edit");
          break;
        case 5:
          this.$router.push("/ecologicalServices/person-edit");
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  background: #fff;
  padding: 20px;
  width: 400px;
  height: 254px;
}
h3 {
  margin: 0;
}
.tagList {
  display: flex;
  flex-wrap: wrap;
}
.tag {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 90px;
  margin-top: 16px;
  .label {
    font-family: Alibaba PuHuiTi;
    font-size: 12px;
    text-align: center;
    color: #666666;
  }
}
</style>